const navbars = [
  {
    routerName: 'Home',
    params: {},
    label: 'ホーム',
    icon: '<i class="fa fa-home" aria-hidden="true"></i>',
    activeRouters: ['Home']
  },
  {
    routerName: 'Warehouses',
    params: {},
    label: '倉庫管理',
    icon: '<img class="img-reponsive inventory-img" src="/static/dists/img/warehouse.svg" alt=""/>',
    activeRouters: [
      'Warehouses',
      'Delivery Requests',
      'Warehouse Amazon',
      'Warehouse across',
      'Warehouse sc',
      'Salemon Agent'
    ]
  },
  {
    routerName: 'ProductsNew',
    params: {tab: 'list'},
    label: '商品管理',
    icon: '<i class="fa fa-gift" aria-hidden="true"></i>',
    activeRouters: ['ProductsNew']
  },
  {
    routerName: 'Revenue',
    params: {},
    label: '売上管理',
    icon: '<i class="fa fa-jpy" aria-hidden="true"></i>',
    activeRouters: ['Revenue', 'ReqMoney']
  },
  {
    routerName: 'Revdetail',
    params: {},
    label: '売上明細',
    icon: '<i class="fa fa-file-text-o" aria-hidden="true"></i>',
    activeRouters: ['Revdetail']
  },
  {
    routerName: 'Promotion',
    params: {tab: 'top'},
    label: '広告管理',
    icon: '<i class="fa fa-bullhorn" aria-hidden="true"></i>',
    activeRouters: ['Promotion']
  },
  {
    routerName: 'Sale',
    params: {tab: 'open'},
    label: 'セール',
    icon: '<i class="fa fa-flag" aria-hidden="true"></i>',
    activeRouters: ['Sale']
  },
  {
    routerName: 'Affiliate',
    params: {tab: 'top'},
    label: '紹介制度',
    icon: '<i class="fa fa-comment-o" aria-hidden="true"></i>',
    activeRouters: ['Affiliate']
  },
  {
    routerName: 'Analysis',
    params: {},
    label: '分析',
    icon: '<i class="fa fa-pie-chart" aria-hidden="true"></i>',
    activeRouters: ['Analysis']
  },
  {
    routerName: 'Premium',
    params: {},
    label: 'プレミアム',
    icon: '<i class="fa fa-diamond" aria-hidden="true"></i>',
    activeRouters: ['Premium']
  },
  {
    routerName: 'VideoList',
    params: {},
    label: 'セルモンTV',
    icon: '<img class="img-reponsive" style="width: 25px; height: 25px; margin: -15px 5px -15px 1px;" src="https://image-yoshino.sakura.ne.jp/monster/TvlogoW_146x154" alt=""/>',
    activeRouters: ['VideoList', 'VideoPlayer']
  },
  {
    routerName: 'Setting',
    params: {tab: 'plan-info'},
    label: '設定',
    icon: '<i class="fa fa-cog" aria-hidden="true"></i>',
    activeRouters: ['Setting']
  },
  {
    routerName: 'Question Answer',
    params: {},
    label: 'Q&A',
    icon: '<i class="fa fa-question-circle-o" aria-hidden="true"></i>',
    activeRouters: ['Question Answer']
  },
  {
    routerName: 'Request',
    params: {},
    label: 'だれでも掲示板',
    icon: '<i class="fa fa-comments" aria-hidden="true"></i>',
    activeRouters: ['Request']
  },
  {
    routerName: 'Notices',
    params: {},
    label: 'お知らせ',
    icon: '<i class="fa fa-bell" aria-hidden="true"></i>',
    activeRouters: ['Notices']
  }
]

export default navbars



// WEBPACK FOOTER //
// ./src/common/sidebar-menu.js